import { Component, PropSync } from 'vue-property-decorator';
import './loading-icon.scss';
import Vue from 'vue';
@Component({})
export default class DualRingLoader extends Vue {
  @PropSync('loading', { type: Boolean, default: true }) syncedLoading!: boolean;
  @PropSync('size', { type: Number, default: 80 }) syncedSize!: number;
  @PropSync('color', { type: String, default: 'white' }) synedColor!: string;
  @PropSync('duration', { type: String, default: '1.2s' }) syncedDuration!: string;

  render() {
    return (
      <div
        v-show="loading"
        class="lds-dual-ring"
        style={{ width: `${this.syncedSize}px`, height: `${this.syncedSize}px` }}
      >
        <div
          class="lds-dual-ring-after"
          style={{
            borderWidth: `${this.syncedSize * 0.075}px`,
            borderColor: `${this.synedColor} transparent`,
            animationDuration: this.syncedDuration
          }}
        ></div>
      </div>
    );
  }
}
